import React from 'react';
import { Clickable } from '@moda/om';
import WarningIcon from '@moda/icons/warning-16';
import { LineItemMiniGranularity } from '../LineItemMini';

import './LineItemSoldOutNote.scss';

interface Props {
  granularity?: LineItemMiniGranularity;
  message: string;
  onSaveForLater: () => void;
}

export const LineItemSoldOutNote: React.FC<Props> = ({
  granularity = LineItemMiniGranularity.Full,
  message,
  onSaveForLater
}) => (
  <>
    <WarningIcon className="LineItemSoldOutNote__warning-icon" />

    <span>
      {message}
      {granularity === LineItemMiniGranularity.Full && (
        <>
          {' '}
          <Clickable className="LineItemSoldOutNote__action" onClick={onSaveForLater}>
            Save for later
          </Clickable>{' '}
          to be notified when item is back in stock.
        </>
      )}
    </span>
  </>
);
